const pageTypes = {
    staticPage: "static page",
    recipeDetail: "recipe detail page",
    notFoundPage: "404 page",
}

module.exports = { pageTypes }
